import { Stack, Link, Typography } from "@mui/material";

const WhatsAppChat = () => (
  <Link href={`https://wa.me/6561007666`}>
    <Stack direction="row" spacing={0.5}>
      <img
        src="/assets/images/whatsapp/WhatsAppIcon.svg"
        style={{
          height: "22px",
          width: "22px",
          maxWidth: "fit-content",
        }}
        alt="Whatsapp Icon"
      />
      <Typography> Chat </Typography>
    </Stack>
  </Link>
);

export default WhatsAppChat;
